var exports = {
  "w": "TimeoutMemberSheet.module__header___SjNBcl",
  "h": "TimeoutMemberSheet.module__description___SjNBcl",
};

module.exports = exports;
